module.exports = __webpack_public_path__ + "static/img/login-background.34d1135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/login-background.png
// module id = c6EA
// module chunks = 0